export const TIPOS_IDENTIFICACION = 2;
export const DEPARTAMENTOS = 7;
export const GENERO = 69 // test y prd 69 // local 67
export const COMUNIDAD = 85 // test y prd 85 // local 83
export const CIUDADES = 8; 
export const AREA_DERECHO = 86 // test y prd 86 // local 84
export const ESTADOS_CONSULTORIA = 88 // test y prd 88 // local 86
export const REQUISITOS_CONSULTORIA = 89 // test y prd 89 // local 87
export const TIPOS_CONSULTORIA = 90 // test y prd 90 // local 88
export const Tipo_informes_consultoria = 199 // test y prd 199 // local 205
export const TIPO_CENTRO_CONCILIACION = 264  // En produccion 264 // local 207 // test 264
export const DOCUMENTOS_INFORMATIVOS = 289 // En produccion 289 // test 289 // local 208
export const VISTA_CONSULTORIA = 362; // En produccion 362 // test 362 // local 213
// Campos sociodemográficos - Requerimiento Ministerio de Justicia 2026
export const RANGO_EDAD = 390 // prd 390 local 209
export const ESTRATO_SOCIOECONOMICO = 391 // prd 391 local 210
export const GRADO_ESCOLARIDAD = 392  //prd 392 local 211
export const VICTIMA_VIOLENCIA = 393  // prd 393 local 212
export const DISCAPACIDADES = 87 // prd 87 local 85

/**
 * Transforma los valores de la generica DISCAPACIDADES en opciones para el select de
 * tipo_discapacidad_consultorio. El value es el codigo (valora) que guarda ese campo:
 * 1 Si, 2 No, 3 Fisica, 4 Sensorial, 5 Mental cognitiva, 6 Mental psicosocial, 7 Sistemica.
 */
export const transformarDiscapacidades = (datos = []) => datos
  .map(({ nombre, valora, codigo }) => ({ value: valora, label: nombre, codigo }))
  .sort((a, b) => a.value - b.value);

/**
 * Bandera del campo discapacidad de personas ('1' Si / '0' No) segun el codigo
 * seleccionado en tipo_discapacidad_consultorio ('2' = No tiene discapacidad).
 */
export const banderaDiscapacidad = (codigo) => (`${codigo}` === '2' ? '0' : '1');
